module.exports = __webpack_public_path__ + "img/depmap_svg_V195.9ba60c07.svg";